<div class="weekly-plan-page" dir="rtl">
  <header class="wp-top">
    <div class="wp-top-inner">
      <div>
        <p class="wp-kicker">{{ 'PLAN.KICKER' | translate }}</p>
        <h1>{{ displaySchoolName }}</h1>
        <p class="wp-top-sub">{{ displayDepartmentName }}</p>
      </div>
      <div class="wp-week-chip" *ngIf="!loading">
        <strong>{{ weekChipLabel }}</strong>
        <span *ngIf="weekPeriodLabel">{{ weekPeriodLabel }}</span>
      </div>
    </div>
  </header>

  <div class="wp-status" *ngIf="statusMessage" [class.error]="statusError">
    {{ statusMessage | translate: statusParams }}
  </div>

  <div class="wp-loading" *ngIf="loading">
    <span class="wp-spinner" aria-hidden="true"></span>
    {{ 'PLAN.LOADING' | translate }}
  </div>

  <ng-container *ngIf="!loading">
    <section class="wp-meta-panel">
      <div class="wp-field" *ngIf="!isTeacherMode && !isReadOnly">
        <label>{{ 'PLAN.SECTION_HEAD' | translate }}</label>
        <select [(ngModel)]="sectionHeadName">
          <option value="">{{ 'PLAN.SELECT_SECTION_HEAD' | translate }}</option>
          <option *ngFor="let head of sectionHeadOptions" [value]="head">{{ head }}</option>
        </select>
      </div>
      <div class="wp-field" *ngIf="isReadOnly && sectionHeadName">
        <label>{{ 'PLAN.SECTION_HEAD' | translate }}</label>
        <div class="wp-readonly-value">{{ sectionHeadName }}</div>
      </div>
      <div class="wp-field">
        <label>{{ 'PLAN.CLASS' | translate }}</label>
        <select [(ngModel)]="classId" (ngModelChange)="onClassChange()">
          <option *ngFor="let cls of classes" [value]="cls.id">{{ cls.name }}</option>
        </select>
      </div>
      <div class="wp-field">
        <label>{{ 'PLAN.WEEK' | translate }}</label>
        <select
          [(ngModel)]="weekOrdinal"
          (ngModelChange)="onWeekChange()"
          [disabled]="(isTeacherMode || isSupervisorMode) && activeWeeks.length <= 1"
        >
          <option *ngFor="let week of weekOptionsForSelect" [ngValue]="week.ordinal">{{ week.name }}</option>
        </select>
        <span class="wp-field-hint" *ngIf="(isTeacherMode || isSupervisorMode) && activeWeeks.length">
          {{ (hasMultipleActiveWeeks ? 'PLAN.ACTIVE_WEEKS_HINT' : 'PLAN.ACTIVE_WEEK_HINT') | translate }}
        </span>
        <span class="wp-field-hint error" *ngIf="(isTeacherMode || isSupervisorMode) && !activeWeeks.length && weeks.length">
          {{ 'PLAN.NO_ACTIVE_WEEK' | translate }}
        </span>
      </div>
    </section>

    <main class="wp-main">
      <div class="wp-toolbar">
        <div class="wp-toolbar-copy">
          <h2>{{ 'PLAN.SUBJECT_TABLES' | translate }}</h2>
          <p>
            {{ entries.length }} {{ 'PLAN.SUBJECTS_COUNT' | translate }}
            · {{ selectedClassName || ('PLAN.NO_CLASS' | translate) }}
            <span *ngIf="isReadOnly"> · {{ 'PLAN.VIEW_ONLY' | translate }}</span>
          </p>
        </div>
        <div class="wp-toolbar-actions" *ngIf="!isTeacherMode && !isSupervisorMode">
          <button
            type="button"
            class="wp-btn ghost"
            (click)="printAll('landscape')"
            [disabled]="exporting || !entries.length"
          >
            <mat-icon>crop_landscape</mat-icon>
            {{ (exporting ? 'PLAN.EXPORTING' : 'PLAN.PRINT_ALL_LANDSCAPE') | translate }}
          </button>
          <button
            type="button"
            class="wp-btn ghost"
            (click)="printAll('portrait')"
            [disabled]="exporting || !entries.length"
          >
            <mat-icon>crop_portrait</mat-icon>
            {{ (exporting ? 'PLAN.EXPORTING' : 'PLAN.PRINT_ALL_PORTRAIT') | translate }}
          </button>
          <button
            type="button"
            class="wp-btn ghost"
            (click)="exportAll()"
            [disabled]="exporting || !entries.length"
          >
            <mat-icon>picture_as_pdf</mat-icon>
            {{ (exporting ? 'PLAN.EXPORTING' : 'PLAN.EXPORT_ALL') | translate }}
          </button>
        </div>
        <div class="wp-toolbar-actions" *ngIf="isSupervisorMode">
          <button
            type="button"
            class="wp-btn ghost"
            (click)="exportAll()"
            [disabled]="exporting || !entries.length"
          >
            <mat-icon>picture_as_pdf</mat-icon>
            {{ (exporting ? 'PLAN.EXPORTING' : 'PLAN.EXPORT_ALL') | translate }}
          </button>
        </div>
      </div>

      <div class="wp-empty" *ngIf="!entries.length">
        <mat-icon>calendar_view_week</mat-icon>
        <strong>{{ 'PLAN.EMPTY_TITLE' | translate }}</strong>
        <span>{{ 'PLAN.EMPTY_HINT' | translate }}</span>
      </div>

      <article
        class="wp-subject-card"
        *ngFor="let entry of entries; let entryIndex = index"
        [attr.id]="'plan-subject-' + entry.subjectId"
        [class.wp-subject-focus]="focusSubjectId === entry.subjectId"
      >
        <div class="wp-card-head">
          <div class="wp-card-head-main">
            <strong class="wp-subject-name">{{ entry.subjectName }}</strong>
            <select
              *ngIf="!isTeacherMode && !isReadOnly"
              class="wp-teacher-select"
              [(ngModel)]="entry.teacherId"
            >
              <option value="">{{ 'PLAN.SELECT_TEACHER' | translate }}</option>
              <option *ngFor="let teacher of teachersForEntry(entry)" [value]="teacher.id">
                {{ teacherDisplayName(teacher) }}
              </option>
            </select>
            <span *ngIf="(isTeacherMode || isReadOnly) && teacherNameForEntry(entry) as teacherName" class="wp-teacher-label">
              {{ 'PLAN.TEACHER_LABEL' | translate }}: {{ teacherName }}
            </span>
          </div>
          <div class="wp-card-actions">
            <button
              *ngIf="!isReadOnly"
              type="button"
              class="wp-btn primary"
              (click)="saveEntry(entryIndex)"
              [disabled]="savingEntryIndex !== null"
            >
              <mat-icon>save</mat-icon>
              {{ (isSavingEntry(entryIndex) ? 'PLAN.SAVING' : 'PLAN.SAVE') | translate }}
            </button>
            <button
              type="button"
              class="wp-btn ghost"
              (click)="copyEntryTable(entryIndex)"
            >
              <mat-icon>content_copy</mat-icon>
              {{ 'PLAN.COPY' | translate }}
            </button>
            <button
              *ngIf="!isReadOnly"
              type="button"
              class="wp-btn ghost"
              (click)="pasteEntryTable(entryIndex)"
              [disabled]="!hasCopiedTable"
            >
              <mat-icon>content_paste</mat-icon>
              {{ 'PLAN.PASTE' | translate }}
            </button>
            <button
              *ngIf="canDeletePlan"
              type="button"
              class="wp-btn ghost danger"
              (click)="requestClearEntryTable(entryIndex)"
            >
              <mat-icon>delete_sweep</mat-icon>
              {{ 'PLAN.CLEAR' | translate }}
            </button>
            <button
              type="button"
              class="wp-btn ghost"
              (click)="exportEntryExcel(entryIndex)"
            >
              <mat-icon>table_view</mat-icon>
              {{ 'PLAN.EXPORT_EXCEL' | translate }}
            </button>
            <button type="button" class="wp-btn ghost" (click)="exportEntry(entryIndex)" [disabled]="exporting">
              <mat-icon>download</mat-icon>
              {{ 'PLAN.EXPORT_PDF' | translate }}
            </button>
          </div>
        </div>

        <div class="wp-capture-area" #captureArea>
          <div class="wp-capture-meta">
            <div class="wp-capture-meta-top">
              <div class="wp-capture-meta-main">
                <div class="wp-meta-subject">{{ entry.subjectName }}</div>
                <div class="wp-meta-line"><b>{{ displaySchoolName }}</b> — {{ displayDepartmentName }}</div>
              </div>
              <div class="wp-capture-logos">
                <img src="assets/weekly-plan/school-logo.png" alt="شعار المدرسة">
                <img src="assets/weekly-plan/year-banner.jpg" alt="بالميثاق نبلغ الآفاق">
              </div>
            </div>
            <div class="wp-capture-meta-bottom">
              <div>{{ selectedClassName }} · {{ weekChipLabel }}</div>
              <div>{{ fmtDisplayDate(startDate) }} إلى {{ fmtDisplayDate(endDate) }}</div>
            </div>
          </div>

          <div class="wp-table-scroll">
            <table class="wp-plan">
              <thead>
                <tr>
                  <th>العنصر</th>
                  <th *ngFor="let day of planDays">{{ day }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of planRows; let rowIndex = index">
                  <th>{{ row.label }}</th>
                  <td
                    *ngFor="let day of planDays; let dayIndex = index"
                    (contextmenu)="openCellMenu($event, entryIndex, rowIndex, dayIndex)"
                  >
                    <textarea
                      [(ngModel)]="entry.grid[rowIndex][dayIndex]"
                      rows="2"
                      [readonly]="isReadOnly"
                      (contextmenu)="openCellMenu($event, entryIndex, rowIndex, dayIndex)"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="wp-teacher-line" *ngIf="teacherNameForEntry(entry) as teacherName">
            معلم المادة: {{ teacherName }}
          </div>
        </div>
      </article>
    </main>
  </ng-container>

  <div
    class="wp-cell-menu"
    *ngIf="cellMenu?.visible"
    [style.left.px]="cellMenu?.x"
    [style.top.px]="cellMenu?.y"
    (click)="$event.stopPropagation()"
    (contextmenu)="$event.preventDefault()"
  >
    <button type="button" class="wp-cell-menu-item" (click)="copyCellFromMenu($event)">
      <mat-icon>content_copy</mat-icon>
      {{ 'PLAN.COPY_CELL' | translate }}
    </button>
    <button
      *ngIf="!isReadOnly"
      type="button"
      class="wp-cell-menu-item"
      (click)="pasteCellFromMenu($event)"
    >
      <mat-icon>content_paste</mat-icon>
      {{ 'PLAN.PASTE_CELL' | translate }}
    </button>
  </div>

  <div class="modal-backdrop" *ngIf="showClearTableModal">
    <div class="modal-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'PLAN.CLEAR_CONFIRM_TITLE' | translate }}</h3>
      </div>
      <div class="modal-body">
        <p>{{ 'PLAN.CLEAR_CONFIRM_BODY' | translate: { subject: clearTableSubjectName } }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onClearTableModalClose(false)">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="onClearTableModalClose(true)">
          {{ 'PLAN.CLEAR' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
